import angular from 'angular';

angular.module('app.core').factory('LegalNotice', LegalNotice);

export default class LegalNotice {

    constructor(legalNotice, $translate) {
        this.translate = $translate;
        this.id = legalNotice.id;
        this.communityIdentity = legalNotice.communityIdentity;
        this.headOffice = legalNotice.headOffice;
        this.email = legalNotice.email;
        this.phone = legalNotice.phone;
        this.website = legalNotice.website;
        this.pubDirector = legalNotice.pubDirector;
        this.designEdition = legalNotice.designEdition;
        this.websiteHosting = legalNotice.websiteHosting;
    }
}